import { jsxs as a, jsx as m } from "@emotion/react/jsx-runtime";
import { useRef as t, useCallback as u } from "react";
import { useIntersectionObserver as x } from "@partoohub/hooks";
import { ScrollContainer as d } from "./InfiniteScroll.styled.js";
const b = ({
  fetchNextPage: s,
  enabled: r,
  children: i,
  className: c,
  root: e,
  rootMargin: l = "0px 0px 25% 0px"
}) => {
  const n = t(null), o = t(null), f = u((p) => {
    p.isIntersecting && s();
  }, []);
  return x({
    target: n,
    callback: f,
    options: {
      root: e ?? o.current,
      rootMargin: l
    },
    dependencies: [],
    enabled: r
  }), /* @__PURE__ */ a(d, { ref: o, root: e, className: c, children: [
    i,
    r && /* @__PURE__ */ m("div", { ref: n })
  ] });
};
export {
  b as InfiniteScroll
};
